<script setup lang="ts">
defineProps({
  position: {
    type: String as PropType<"top" | "bottom">,
    default: "top",
  },
})

const products = useProductVariantsStore()

//Different product states
const productReleased = computed(() => {
  if (products.activeVariant) {
    return products.activeVariant.isReleased
  } else {
    return products.productVariants.some(p => p.isReleased)
  }
})

const variant = computed(() => products.activeProduct?.variants.find(v => !!v.ean))
</script>

<template>
  <section
    class="flex items-center justify-center w-full"
    :class="{ 'bg-[--theme-lighter]': position === 'bottom' }"
  >
    <div
      class="max-w-[90em]"
      :class="{
        'grid-cols-2 place-items-center gap-6 flex flex-col lg:grid':
          position === 'top',
        'flex items-center justify-center': position === 'bottom',
      }"
    >
      <UProductImage
        v-if="position === 'top' && variant"
        :product="variant"
        loading="eager"
        class="lg:order-2 flex items-center justify-center max-w-[248px] md:max-w-[400px] lg:max-w-[465px] lg:self-start"
        img-class="w-fit max-w-full rounded-lg object-contain"
      />
      <div
        v-if="products.activeProduct"
        class="flex flex-col gap-5 lg:gap-10 lg:px-0"
        :class="{
          'text-center ': position === 'bottom',
          'text-left ': position === 'top',
        }"
      >
        <div v-if="position === 'top'">
          <h2
            class="font-numeraWebRegular text-pretty hyphens-auto text-center lg:text-left text-marketing-mobile-h2-h2-caption text-[--theme-darkest] md:text-marketing-desktop-h2-h2-caption xl:gap-10"
            v-html="products.activeProduct?.header"
          ></h2>

          <h3
            v-if="!productReleased"
            class="font-national2condensed text-center lg:text-left text-marketing-mobile-p1-p1-regular-m lg:text-marketing-desktop-p1-p1-regular-s text-[--theme-dark]"
          >
            Produktet lanseres snart, da kan du prøve oss helt gratis
          </h3>
        </div>

        <UProductActions
          v-if="products.activeProduct"
          :product="products.activeProduct"
          view-type="detail"
          :align="position === 'bottom' ? 'center' : 'left'"
          :show-status-details="true"
        />
      </div>
    </div>
  </section>
</template>
